import type { DamageType } from "../damageType";
import { DestroyableObstacle } from "../destroyableObstacle";
import { deserializeXY } from "../serialization";
import type { Thing } from "../thing";
import type { XY } from "../xy";
import { Gas } from "./gas";

export class GasBarrel extends DestroyableObstacle {
	static key = "GasBarrel";
	constructor(xy: XY) {
		super(xy);
	}

	protected onZeroHp(source: Thing | null, type: DamageType | null): void {
		const gas = new Gas(this.xy, 80);
		this.board!.addThing(gas);
		super.onZeroHp(source, type);
	}

	static deserialize(data: any): GasBarrel {
		const b = new GasBarrel(deserializeXY(data.xy));
		b.restoreBaseFields(data);
		return b;
	}
}
